import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import type {Artifact} from '../types'
import {ArtifactListItem} from './ArtifactListItem'

interface ArtifactsListProps {
  org: string
  artifacts: Artifact[]
  totalCount: number
}

export function ArtifactsList(props: ArtifactsListProps) {
  const {org, artifacts, totalCount} = props

  const formatNumber = (num: number): string => {
    return num.toLocaleString()
  }
  const listTitle = `${formatNumber(totalCount)} ${totalCount === 1 ? 'artifact' : 'artifacts'}`

  return (
    <ListView
      variant="default"
      title="Artifacts List"
      titleHeaderTag="h3"
      className="border rounded"
      metadata={<ListViewMetadata title={listTitle} />}
    >
      {artifacts.map(artifact => (
        <ArtifactListItem key={`artifact-${artifact.artifact_metadata_id}`} artifact={artifact} org={org} />
      ))}
    </ListView>
  )
}

try{ ArtifactsList.displayName ||= 'ArtifactsList' } catch {}